import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "@fontsource/almarai/300.css"; // Light weight
import "@fontsource/almarai/400.css"; // Regular weight
import "@fontsource/almarai/700.css"; // Bold weight
import "@fontsource/almarai/800.css"; // Extra Bold weight

import "@fontsource/inter/300.css"; // Light weight
import "@fontsource/inter/400.css"; // Regular weight
import "@fontsource/inter/500.css"; // Regular weight
import "@fontsource/inter/700.css"; // Bold weight
import "@fontsource/inter/800.css"; // Extra Bold weight
import reportWebVitals from "./reportWebVitals";
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  //   <React.StrictMode>
  <App />
  //   </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
